import React, { useState, useEffect } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  searchInstallment,
  downloadInstallmentIncomeDetail,
} from '../../redux/actions/projectBasedItems'
import {
  sessionSetItemObj,
  sessionGetItemStr,
  sessionGetItemJSON,
} from '../../utils/sessionHelpers'
import VoucherListTable from './VoucherListTable'
import { startLoading, doneLoading } from '../../utils/loading'
import { sessionGetItemObj, sessionRemoveItem } from '../../utils/sessionHelpers'
import AccountingPeriodWidget from '../panelHeder/AccountingPeriodWidget'
import MiniProjectInfo from './MiniProjectInfo'
import { downloadPaymentVoucherFile } from '../../redux/actions/accountingExpenses'
import { downloadRecieptVoucherFile } from '../../redux/actions/incomeAndExpense'
import moment from 'moment'
import { DATE_FORMAT, DD_MM_YYYY_SLASH, REQUEST_DATE_FORMAT } from '../../constants/date'

export default function VoucherListWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)

  const history = useHistory()

  const projectCode = sessionStorage.getItem('projectCode')
  const { periodNumber } = sessionGetItemObj('periodInfo')
  const periodInfo = sessionGetItemJSON('periodInfo')

  const handlePreviewVoucher = async (fileObj) => {
    console.log('handlePreviewVoucher', fileObj)

    startLoading()
    setIsLoading(true)

    var file
    if (fileObj.type == 'Expense') {
      file = await downloadPaymentVoucherFile(fileObj.id)
      // console.log('Expense', fileObj.id)
    } else if (fileObj.type == 'Income') {
      file = await downloadRecieptVoucherFile(fileObj.id)
      // console.log('Income', fileObj.id)
    }

    // var file = await downloadInstallmentIncomeDetail(fileObj.pathFile)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()

    setIsLoading(false)
    doneLoading()
  }

  const handleSearchInstallment = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await searchInstallment(request, projectCode, periodNumber)
      // console.log('resssss 99999 ', response)
      setFormSchema(response.model)
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSelectVoucher = (rowData, type) => {
    console.log('rowData ', rowData)

    // กรณีกดแก้ไขข้อมูล
    if (rowData) {
      sessionSetItemObj('voucherInfo', rowData)
    } else {
      sessionRemoveItem('voucherInfo')
    }

    if (rowData?.type == 'Income' || type == 'Income') {
      history.push({
        pathname: pathname.incomeAndExpense.IncomeRecord,
      })
    } else {
      history.push({
        pathname: pathname.incomeAndExpense.ExpenseRecord,
      })
    }
  }

  const handleOnSearchVoucher = async (
    txtRecordTypeVal,
    txtVoucherNumberVal,
    txtActivityCodeVal,
    txtDescriptionVal,
    startDate,
    endDate
  ) => {
    const request = {
      recordType: txtRecordTypeVal || 0,
      voucherNumber: txtVoucherNumberVal,
      activityCode: txtActivityCodeVal,
      description: txtDescriptionVal,
      startDate: startDate ? moment(startDate).format(DD_MM_YYYY_SLASH) : '',
      endDate: endDate ? moment(endDate).format(DD_MM_YYYY_SLASH) : '',
    }

    handleSearchInstallment(request)
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={<AccountingPeriodWidget periodInfo={periodInfo} />}
      >
        {formSchema?.projectInfo && (
          <>
            <MiniProjectInfo schema={formSchema.projectInfo} />
            <br />
          </>
        )}

        <VoucherListTable
          schema={formSchema}
          Controller={Controller}
          control={control}
          pagination={true}
          loading={isLoading}
          onSelect={handleSelectVoucher}
          onSearch={handleOnSearchVoucher}
          onCancel={() => {
            handleSearchInstallment({})
          }}
          onPreview={handlePreviewVoucher}
        />

        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
